angular
  .module("app")
  .controller("CampanhaShowController", function ($scope, $http, $timeout) {
    $scope.novidades = [];
    $scope.mensagens = [];
    $scope.doadores = [];
    $scope.novidadesObtidas = false;
    $scope.mensagensObtidas = false;
    $scope.totalDoadores = 0;
    $scope.denuncia = {
      descricao: "",
    };

    $scope.getNovidades = function () {
      if ($scope.novidadesObtidas) return;

      $scope.carregandoNovidades = true;
      $http({
        url: window.location.href.split("#")[0] + "/novidades",
        ignorarCatchInterceptor: true,
      }).then(function (res) {
        $scope.novidades = res.data;
        $scope.novidadesObtidas = true;
        $scope.carregandoNovidades = false;
      });
    };

    $scope.getMensagens = function () {
      $scope.carregandoMensagens = true;

      var url = window.location.href.split("#")[0] + "/mensagens";

      if ($scope.mensagensNextPageUrl) {
        url = $scope.mensagensNextPageUrl;
      }

      $http({
        url: url,
        ignorarCatchInterceptor: true,
      }).then(function (res) {
        res.data.mensagens.forEach(function (mensagem) {
          $scope.mensagens.push(mensagem);
        });

        $scope.totalMensagens = res.data.total;
        $scope.carregandoMensagens = false;
        $scope.mensagensNextPageUrl = res.data.next_page_url;
      });
    };

    $scope.getDoadores = function () {
      $scope.carregandoDoadores = true;

      var url = window.location.href.split("#")[0] + "/doadores";

      if ($scope.doadoresNextPageUrl) {
        url = $scope.doadoresNextPageUrl;
      }

      $http({
        url: url,
        ignorarCatchInterceptor: true,
      }).then(function (res) {
        res.data.doadores.forEach(function (doador) {
          $scope.doadores.push(doador);
        });

        $scope.totalDoadores = res.data.total;
        $scope.carregandoDoadores = false;
        $scope.doadoresNextPageUrl = res.data.next_page_url;
      });
    };

    $scope.exibirBtnMaisDoadores = function () {
      return $scope.doadoresNextPageUrl;
    };

    $scope.exibirBtnMaisMensagens = function () {
      return $scope.mensagensNextPageUrl;
    };

    $scope.denunciar = function () {
      if ($scope.denuncia.descricao.length < 20) {
        alert("Descreva a denúncia com ao menos 20 caracteres.");
        return false;
      }

      if ($scope.denuncia.descricao.length > 4000) {
        alert("Descreva a denúncia com ao até 4000 caracteres.");
        return false;
      }

      $scope.salvandoDenuncia = true;

      $http({
        url: window.location.href.split("#")[0] + "/denunciar",
        method: "post",
        data: $scope.denuncia,
      })
        .then(function (res) {
          if (res.data.status) {
            alert(res.data.msg);
            window.location.href = "/";
          }
        })
        .catch(function (err) {
          $scope.salvandoDenuncia = false;
        });
    };

    $scope.copiarParaAreaDeTransferencia = function (
      elementId,
      elementSuccessId
    ) {
      var copyText = document.getElementById(elementId);

      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");

      $("#" + elementSuccessId)
        .hide()
        .removeClass("hide")
        .fadeIn("slow", function () {
          setTimeout(function () {
            $("#" + elementSuccessId).fadeOut();
          }, 2000);
        });
    };

    $scope.baixarQrCode = function () {
      var a = document.createElement("a");

      var toDataURL = function (url) {
        return fetch(url)
          .then((response) => {
            return response.blob();
          })
          .then((blob) => {
            return URL.createObjectURL(blob);
          });
      };

      toDataURL(angular.element(".qrcode-output img").attr("src")).then(
        function (res) {
          a.href = res;
          a.download = "qr-code.png";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      );
    };
  });
